.members-option {
	display: flex;
	align-items: center;
	& .title {
		padding-left: calc(0.5 * var(--jpo-common-base-spacing));
	}
}
